import React, { Component } from 'react';
import {FormattedMessage} from "react-intl";
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import Quantity from "../../ui/quantity";
import {s3FeatureImagePath, THUMBNAIL_SIZES} from "../../../misc/utils";
import FeatureInfoPrice from "./featureInfoPrice";
import {setRelatedGroups, toggleGalleryVisible} from "../../../actions/selectionFunctions";
import {getFeatureIsLocked} from "../../../misc/helpers";
import FeatureInfoPriceLocked from "./featureInfoPriceLocked";
import FeatureName from "../../visComponents/featureName";
import FeatureDescription from "../../visComponents/featureDescription";
import FeatureInfoAssociatedProductSideOptions from "./featureInfoAssociatedProductSideOptions";
import FeatureInfoAssociatedProductShelfOptions from "./featureInfoAssociatedProductShelfOptions";

class FeatureInfoAssociatedProduct extends Component {

  static propTypes = {
    relatedFeature: PropTypes.object.isRequired,
    allRelatedFeatures: PropTypes.array.isRequired,
    handleFeatureClick: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
  };

  componentDidMount() {

  }

  handleChangeItemQuantity = (value) => {
    const relatedGroups = this.props.relatedGroups.map(relatedGroup => {
      relatedGroup.relatedFeatures.map(relatedFeature => {
        if (relatedFeature.dbFeature.id === this.props.relatedFeature.dbFeature.id) {
          relatedFeature.cartQuantity = value;
          if (value) {
            this.handleRelatedItemClick();
          }
        }
        return relatedFeature
      });
      return relatedGroup
    });
    this.props.setRelatedGroups(relatedGroups);
  };

  sideOptionClick = (featureClicked) => {
    const relatedGroups = this.props.relatedGroups.map(relatedGroup => {
      relatedGroup.relatedFeatures.map(relatedFeature => {
        const parent = relatedFeature.getParent();
        if (parent.layerPositions && featureClicked && (parent.partId === featureClicked.partId)) {
          relatedFeature.cartQuantity = Object.keys(parent.layerPositions).reduce((acc, position) => {
            if (parent.layerPositions[position]?.dbFeature?.sharedFeatureName === relatedFeature.dbFeature.sharedFeatureName) {
              acc++
            }
            return acc;
          }, 0);
        }
        return relatedFeature
      });
      return relatedGroup
    });
    this.props.setRelatedGroups(relatedGroups);
  };

  handleRelatedItemClick = () => {
    this.props.handleFeatureClick({
      part: this.props.relatedFeature
    });
    this.sideOptionClick(this.props.relatedFeature);
  };

  render() {

    const {relatedFeature, isActive, fabricatorData, allRelatedFeatures} = this.props;
    const fabricatorSettings = fabricatorData.settings;
    const imageUrl = (relatedFeature.dbFeature.thumbnailUrl)
        ? s3FeatureImagePath(relatedFeature.dbFeature, THUMBNAIL_SIZES.medium)
        : relatedFeature.customThumbnail;
    const isMobile = this.props.windowWidth < 991;
    const showGalleryButton =  relatedFeature.dbFeature.galleryImages
      && relatedFeature.dbFeature.galleryImages.length;

    const showPriceLocked = getFeatureIsLocked(relatedFeature);
    const showPrice = fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost && !showPriceLocked && !fabricatorData.hidePricesFromUser;

    return (
      <div className="accItem" data-feature-id={relatedFeature.dbFeature.id}>
        <div className={"accItem-image" + (isActive ? " accItem-image--active" : "")} onClick={this.handleRelatedItemClick}>
          <div className="accItem-image__block">
            {imageUrl ? <img src={imageUrl} className="accItem-image__block-img" alt=""/> : null}
            {showGalleryButton
              ? <button className="selection-main__image-button selection-main__image-button--image-related"
                        onClick={() => this.props.toggleGalleryVisible(true, relatedFeature)}/>
              : null}
            {relatedFeature.notAvailableInVisualizer && allRelatedFeatures.some(f => !f.notAvailableInVisualizer) ? (
              <div className={"feature-text feature-text--not-in-visualizer"}>
                <FormattedMessage id="quotingTool.canvas.featureNotAvailableTitle"/>
              </div>
            ) : null}
          </div>
        </div>
        <div className="accItem-content">
          <h4 className="accItem-title">
            <FeatureName feature={relatedFeature}/>
          </h4>
          <div className="accItem-actions">
            <div className="accItem-actions__left">
              <FeatureDescription className="accItem-description" feature={relatedFeature}/>
              {isMobile || !showPrice ? null : (
                <div className="accItem-price">
                  <FeatureInfoPrice feature={relatedFeature} accItemQuantity={relatedFeature.cartQuantity || 1}/>
                  {/*<div className="accItem-price__content">{getPriceWithCurrency(fabricatorSettings, relatedFeature.price, relatedFeature)}</div>*/}
                  {/*{relatedFeature.dbFeature.sku ? <div className="accItem-price__model">{relatedFeature.dbFeature.sku}</div> : null}*/}
                </div>
              )}
              <FeatureInfoAssociatedProductSideOptions activeFeature={relatedFeature}
                                                       parentOptionClick={this.sideOptionClick}/>
              {relatedFeature.partId === "corner_shelf" || relatedFeature.partId === "body_spray"
                ? <FeatureInfoAssociatedProductShelfOptions activeFeature={relatedFeature}
                                                            parentOptionClick={this.sideOptionClick}/>
                : null}
            </div>
            <div className="accItem-quantity">
              {showPrice ? <FeatureInfoPrice feature={relatedFeature}
                                                        mainFeaturePrice={true}
                                                        accItemQuantity={relatedFeature.cartQuantity || 1}/> : null}
              {showPriceLocked ? <FeatureInfoPriceLocked textOnly={true}/> : null}
              <Quantity size={isMobile? "big" : "normal"}
                        squared={true}
                        changeValue={this.handleChangeItemQuantity}
                        value={relatedFeature.cartQuantity || 0}/>
            </div>
          </div>
          {/*<ul className="accItem-options">*/}
          {/*{relatedFeature.options.map((select, selectIndex) => {*/}
          {/*return (*/}
          {/*<li className="accItem-options__option" key={selectIndex}>*/}
          {/*<h6 className="accItem-options__title">{select.selectTitle}</h6>*/}
          {/*<select className={"user-popup-fields__item-input user-popup-fields__item-select"}>*/}
          {/*{select.selectOptions.map((option, optionIndex) => {*/}
          {/*return <option value={option} key={optionIndex}>{option}</option>*/}
          {/*})}*/}
          {/*</select>*/}
          {/*</li>*/}
          {/*)*/}
          {/*})}*/}
          {/*</ul>*/}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    relatedGroups: store.selectionState.relatedGroups,
    cartItems: store.cartState.cartItems,
    selectionFeatureInfo: store.selectionState.selectionFeatureInfo,
    fabricatorData: store.fabricatorState,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    windowWidth: store.serverState.windowWidth,
  };
};

export default connect(mapStateToProps, {
  setRelatedGroups,
  toggleGalleryVisible
})(FeatureInfoAssociatedProduct);
